// ========================================
// Program View - UI & Rendering Logic
// ========================================

Object.assign(ProgramView, {
// Programación lectiva, diseño A2 (2026-10-26): cabecera en una línea, tipo y formación como
    // botones, cuatro cifras, el calendario con las casillas pintadas enteras (se imprime aparte, en
    // #print-container) y a la derecha, más ancha, la tabla de asignaturas del mes; debajo, las
    // sesiones extra. Estilos: assets/css/views/calendar.css (.pg-*). Los ids los usan index.js,
    // calendar.js y subjects.js.
    render() {
        this.loadCurrentFormation();

        if (this.currentFormation) {
            const subjects = DataManager.getSubjectsByFormation(this.currentFormation.id);
            subjects.forEach((s, i) => this.getColorForSubject(s.id, i));
        }

        const isStudent = AuthManager.isStudent() || !AuthManager.canManageModule('plan-estudios');
        const status = this.calculateLoadStatus();

        return `
            <div class="program-view-container dnr-proposal pg-view ${isStudent ? 'is-readonly' : ''}">
                <header class="pg-head">
                    <div class="pg-head-title">
                        <h1 class="pg-title">${isStudent ? 'Programación académica' : 'Programación lectiva'}</h1>
                        <select id="program-academic-year-badge" class="dnr-mono program-year-badge" ${UIEvents.attr("change", function(event,captured){ProgramView.changeAcademicYear(this.value);}, [])} aria-label="Curso académico" title="Curso académico">
                            ${this.renderAcademicYearOptions()}
                        </select>
                    </div>
                    ${isStudent ? '' : `
                    <div class="pg-head-actions">
                        <button type="button" class="pg-btn" id="program-export-pdf"><i class="fas fa-file-pdf"></i> Exportar PDF</button>
                        <button type="button" class="pg-btn is-primary" id="new-subject-btn"><i class="fas fa-plus"></i> Asignar asignatura</button>
                    </div>`}
                </header>

                <nav class="tab-navigation pg-bar" id="formation-tabs" aria-label="Tipo y formación">
                    ${this.renderTabs()}
                </nav>

                ${isStudent ? '' : `
                <div class="pg-stats">
                    <div class="pg-stat" title="${status.assigned} de ${status.total} días lectivos">
                        <span class="pg-stat-l">Días lectivos con clase</span>
                        <span class="pg-stat-n is-teal" id="progress-percentage">${status.percentage}%</span>
                        <span class="pg-meter" aria-hidden="true"><i id="progress-bar-fill" style="width: ${status.percentage}%;"></i></span>
                        <span class="pg-stat-s" id="progress-stats-label">${status.assigned} de ${status.total} días lectivos</span>
                    </div>
                    <div class="pg-stat">
                        <span class="pg-stat-l">Horas programadas</span>
                        <span class="pg-stat-n" id="total-hours">0 h</span>
                        <span class="pg-stat-s">en todo el curso</span>
                    </div>
                    <div class="pg-stat">
                        <span class="pg-stat-l">Coste asignado</span>
                        <span class="pg-stat-n" id="total-cost">0 €</span>
                        <span class="pg-stat-s">según la tarifa de cada profesor</span>
                    </div>
                    <div class="pg-stat">
                        <span class="pg-stat-l">Sesiones extra del mes</span>
                        <span class="pg-stat-n is-amber" id="extra-sessions-total">0</span>
                        <span class="pg-stat-s" id="extra-sessions-caption">ninguna</span>
                    </div>
                </div>`}

                <div class="pg-main">
                    <section class="pg-card pg-calendar">
                        <div class="pg-cal-head">
                            <h2 class="pg-h2 pg-month" id="current-month"></h2>
                            <button type="button" class="pg-nav" id="prev-month" aria-label="Mes anterior"><i class="fas fa-chevron-left"></i></button>
                            <button type="button" class="pg-nav" id="next-month" aria-label="Mes siguiente"><i class="fas fa-chevron-right"></i></button>
                        </div>
                        <div class="pg-picking" id="pg-picking" hidden></div>
                        <div class="calendar-grid ${this.selectedSubjectId ? 'assignment-mode' : ''}" id="calendar-grid"></div>
                        <div class="pg-legend">
                            <span><i class="pg-key is-holiday"></i> Festivo</span>
                            <span><i class="pg-key is-today"></i> Hoy</span>
                            <span>Dos colores: dos clases ese día</span>
                        </div>
                    </section>

                    <section class="pg-card pg-subjects">
                        <div class="pg-card-head">
                            <h2 class="pg-h2">Asignaturas del mes · <span id="pg-subjects-count">0</span></h2>
                            ${isStudent ? '' : '<span class="pg-hint">Pulsa una para ponerla en días · arrastra <i class="fas fa-grip-vertical"></i> para ordenar</span>'}
                        </div>
                        <div class="pg-table-wrap">
                            <div class="pg-subjects-head" aria-hidden="true">
                                <span></span><span></span><span>Asignatura y profesor</span><span>Aula</span><span>Tipo</span><span>Horario</span><span>Observaciones</span><span></span>
                            </div>
                            <div class="subjects-list" id="subjects-list"></div>
                        </div>
                    </section>
                </div>

                <section class="pg-card extra-sessions-section pg-extras">
                    <div class="pg-card-head">
                        <h2 class="pg-h2">Sesiones extra / evaluación · <span id="extra-sessions-count">0</span></h2>
                        <span class="pg-hint">Clases que coinciden el mismo día o se salen del horario de su asignatura</span>
                    </div>
                    <div class="pg-extras-list" id="extra-sessions-grid"></div>
                </section>

                <!-- Print-only container (hidden via CSS) -->
                <div id="print-container" class="print-only-container"></div>
            </div>
        `;
    },

    /**
     * Cursos académicos disponibles en el selector de la cabecera: todos los
     * que tengan al menos una clase programada (cualquier formación, no solo
     * la actual), más el curso real de hoy como ancla aunque no haya datos
     * todavía. Mismo criterio de "inicio de curso" que ya usaba el badge
     * (septiembre-agosto: mes 0-indexado >= 8 pertenece al año en curso).
     */
    getAcademicYearStarts() {
        const toYearStart = (dateStr) => {
            const d = new Date(dateStr);
            const m = d.getMonth();
            const y = d.getFullYear();
            return m >= 8 ? y : y - 1;
        };

        const today = new Date();
        const years = new Set([toYearStart(today)]);
        // Years not loaded yet still appear: the server lists every year with classes.
        if (typeof FileStorage !== 'undefined') (FileStorage.classYears || []).forEach(y => years.add(y));

        (DataManager.getClasses() || []).forEach(c => {
            if (c.startDate) years.add(toYearStart(c.startDate));
        });

        return [...years].sort((a, b) => b - a);
    },

    renderAcademicYearOptions() {
        const m = this.currentMonth.getMonth();
        const y = this.currentMonth.getFullYear();
        const selectedYearStart = m >= 8 ? y : y - 1;

        const years = this.getAcademicYearStarts();
        if (!years.includes(selectedYearStart)) years.unshift(selectedYearStart);
        years.sort((a, b) => b - a);

        return years.map(startYear => `
            <option value="${startYear}" ${startYear === selectedYearStart ? 'selected' : ''}>CURSO ${startYear} / ${startYear + 1}</option>
        `).join('');
    },

    changeAcademicYear(yearStart) {
        const y = parseInt(yearStart, 10);
        if (Number.isNaN(y)) return;

        // 1 de septiembre del curso elegido — mismo punto de partida que usa
        // el propio badge para calcular a qué curso pertenece un mes.
        this.currentMonth = new Date(y, 8, 1);
        this.initializeVisibleSubjects();
        this.renderCalendar();
    },

    renderTabs() {
        let formations = DataManager.getFormations();
        if (AuthManager.isStudent()) {
            const studentId = AuthManager.getStudentId();
            if (studentId) {
                const student = DataManager.getById(DataManager.KEYS.STUDENTS, studentId);
                if (student && student.formations) {
                    formations = formations.filter(f => student.formations.includes(f.id));
                } else {
                    formations = [];
                }
            }
        }
        if (AuthManager.isProfessor() && !AuthManager.hasModule('plan-estudios')) {
            const professorId = AuthManager.getProfessorId();
            if (professorId) {
                formations = formations.filter(f => {
                    const hasSubject = DataManager.getSubjectsByFormation(f.id).some(s => s.professorId === professorId);
                    const hasClass = DataManager.getClassesByFormation(f.id).some(c => c.professorId === professorId);
                    return hasSubject || hasClass;
                });
            } else {
                formations = [];
            }
        }
        if (formations.length === 0) return '';

        const types = [...new Set(formations.map(f => f.type))];
        const typeOrder = FormationTypeService.getTypes().map(t => t.id);
        types.sort((a, b) => {
            const idxA = typeOrder.indexOf(a);
            const idxB = typeOrder.indexOf(b);
            return (idxA > -1 ? idxA : 99) - (idxB > -1 ? idxB : 99);
        });

        const categoryHtml = `
            <div class="category-tabs pg-group" role="group" aria-label="Tipo de formación">
                <span class="pg-bar-label">Tipo</span>
                ${types.map(type => {
                    const isActive = this.currentCategory === type;
                    return `
                        <button type="button" class="pg-chip ${isActive ? 'is-on' : ''}" aria-pressed="${isActive}"
                            ${UIEvents.attr("click", function(event,captured){ProgramView.switchCategory(String(captured[0]));}, [type])}>
                            ${Utils.sanitizeHTML(FormationTypeService.plural(type))}
                        </button>`;
                }).join('')}
            </div>
        `;

        const categoryFormations = (AuthManager.isProfessor() && !AuthManager.hasModule('plan-estudios')) ? formations : formations.filter(f => f.type === this.currentCategory);
        const isStudent = AuthManager.isStudent() || !AuthManager.canManageModule('plan-estudios');
        const formationHtml = `
            <div class="formation-sub-tabs pg-group" role="group" aria-label="Formación">
                <span class="pg-bar-label">Formación</span>
                ${categoryFormations.map(f => {
                    const isActive = this.currentFormation && String(f.id) === String(this.currentFormation.id);
                    return `
                        <button type="button" class="formation-tab-item pg-chip ${isActive ? 'active is-on' : ''}" aria-pressed="${!!isActive}"
                                draggable="${isStudent ? 'false' : 'true'}" data-id="${Utils.sanitizeHTML(f.id)}"
                                ${UIEvents.attr("click", function(event,captured){ProgramView.switchFormation(String(captured[0]));}, [f.id])}>
                            ${isStudent ? '' : '<span class="drag-handle" aria-hidden="true"><i class="fas fa-grip-vertical"></i></span>'}
                            <span>${Utils.sanitizeHTML(f.name)}</span>
                        </button>`;
                }).join('')}
            </div>
        `;

        // ── Student simplified view: just formation name + PDF button in one row ──
        if (AuthManager.isStudent()) {
            const f = this.currentFormation;
            return `
                <div class="pg-student-bar">
                    <span class="pg-student-name">${f ? Utils.sanitizeHTML(f.name) : ''}</span>
                    <button type="button" class="pg-btn" id="program-export-pdf"><i class="fas fa-file-pdf"></i> Exportar PDF</button>
                </div>
            `;
        }

        if (AuthManager.isProfessor() && !AuthManager.hasModule('plan-estudios')) {
            return `
                <div class="tabs-container pg-tabs">
                    ${this.renderProgramCascade(types, categoryFormations, false)}
                    ${formationHtml}
                </div>
            `;
        }

        return `
            <div class="tabs-container pg-tabs">
                ${this.renderProgramCascade(types, categoryFormations, true)}
                ${categoryHtml}
                ${formationHtml}
            </div>
        `;
    },

    // Phone (formaciones.css): type › training programme folded into one line. Tapping a level
    // unfolds its options; choosing a type opens its programmes; choosing one folds it again.
    renderProgramCascade(types, categoryFormations, withCategory) {
        const open = this._cascadeOpen;
        const current = this.currentFormation;
        const segment = (level, label) => `
            <button type="button" class="sp-cascade-seg ${open === level ? 'is-open' : ''}" aria-expanded="${open === level}"
                ${UIEvents.attr("click", function(event,captured){ProgramView.toggleProgramLevel(String(captured[0]));}, [level])}>
                <span>${Utils.sanitizeHTML(label)}</span><i class="fas fa-chevron-down" aria-hidden="true"></i>
            </button>`;
        const list = open === 'cat' && withCategory
            ? types.map(type => ({id: type, label: FormationTypeService.plural(type), icon: FormationTypeService.icon(type).replace(/[^a-z0-9-]/g, ''), active: type === this.currentCategory}))
            : open === 'formation' ? categoryFormations.map(f => ({id: f.id, label: f.name, icon: 'fa-graduation-cap', active: !!current && String(f.id) === String(current.id)}))
            : null;
        const level = open === 'cat' ? 'cat' : 'formation';
        return `
            <nav class="sp-cascade prog-cascade" aria-label="Tipo y formación">
                <div class="sp-cascade-bar">
                    ${withCategory ? `${segment('cat', FormationTypeService.plural(this.currentCategory))}<i class="fas fa-angle-right sp-cascade-sep" aria-hidden="true"></i>` : ''}
                    ${segment('formation', current ? current.name : 'Elige formación')}
                </div>
                ${list ? `<div class="sp-cascade-options" role="listbox">${list.map(o => `
                    <button type="button" role="option" aria-selected="${o.active}" class="sp-cascade-option ${o.active ? 'is-active' : ''}"
                        ${UIEvents.attr("click", function(event,captured){ProgramView.pickProgramLevel(String(captured[0]), String(captured[1]));}, [level, o.id])}>
                        <i class="fas ${o.icon}" aria-hidden="true"></i><span>${Utils.sanitizeHTML(o.label)}</span>
                        ${o.active ? '<i class="fas fa-check sp-cascade-check" aria-hidden="true"></i>' : ''}
                    </button>`).join('')}</div>` : ''}
            </nav>`;
    },

    toggleProgramLevel(level) {
        this._cascadeOpen = this._cascadeOpen === level ? null : level;
        const tabsContainer = document.getElementById('formation-tabs');
        if (tabsContainer) SafeHTML.set(tabsContainer, this.renderTabs());
    },

    pickProgramLevel(level, value) {
        if (level === 'cat') {
            this._cascadeOpen = 'formation';
            if (this.currentCategory !== value) return this.switchCategory(value);
            const tabsContainer = document.getElementById('formation-tabs');
            if (tabsContainer) SafeHTML.set(tabsContainer, this.renderTabs());
        } else {
            this._cascadeOpen = null;
            this.switchFormation(value);
        }
    },

    switchCategory(type) {
        console.log('Switching category to:', type);
        if (this.currentCategory === type) {
            console.log('Category already active:', type);
            return;
        }

        this.currentCategory = type;
        console.log('Current category updated to:', this.currentCategory);

        const formations = DataManager.getFormations();
        const firstOfCategory = formations.find(f => f.type === type);

        if (firstOfCategory) {
            this.currentFormation = firstOfCategory;
        } else {
            this.currentFormation = null;
        }

        const tabsContainer = document.getElementById('formation-tabs');
        if (tabsContainer) {
            SafeHTML.set(tabsContainer, this.renderTabs());
        }

        setTimeout(() => {
            if (firstOfCategory) {
                console.log('Auto-switching to first formation:', firstOfCategory.name);
                this.switchFormation(firstOfCategory.id);
            } else {
                App.render();
            }
        }, 0);
    },

    switchFormation(formationId) {
        console.log('Switching to formation:', formationId);

        this.currentFormation = DataManager.getFormation(formationId);

        if (this.currentFormation) {
            this.currentCategory = this.currentFormation.type;
        }

        this.selectedSubjectId = null;
        this.isSelectingNewSubject = false;

        this.subjectColors = {};
        if (this.currentFormation) {
            const subjects = DataManager.getSubjectsByFormation(this.currentFormation.id);
            subjects.forEach((s, i) => this.getColorForSubject(s.id, i));
        }

        this.initializeVisibleSubjects();

        const tabsContainer = document.getElementById('formation-tabs');
        if (tabsContainer) {
            SafeHTML.set(tabsContainer, this.renderTabs());
        }

        this.renderCalendar();
        this.renderSubjects();
        this.renderExtraSessions();
        this.renderDashboard();
        this.updateSummary();

        Utils.showToast(`Cambiado a ${this.currentFormation.name} `, 'info');
    },

    reorderFormations(draggedId, targetId) {
        const formations = DataManager.getFormations();

        const draggedIndex = formations.findIndex(f => f.id === draggedId);
        const targetIndex = formations.findIndex(f => f.id === targetId);

        if (draggedIndex === -1 || targetIndex === -1) return;

        const [movedFormation] = formations.splice(draggedIndex, 1);
        formations.splice(targetIndex, 0, movedFormation);

        const newOrderIds = formations.map(f => f.id);
        FormationService.updateFormationsOrder(newOrderIds);

        App.navigate('calendario-formacion');
        Utils.showToast('Orden de formaciones actualizado', 'success');
    },

    renderExtraSessions() {
        const grid = document.getElementById('extra-sessions-grid');
        if (!grid || !this.currentFormation) return;

        const allClasses = DataManager.getClassesByFormation(this.currentFormation.id);

        const year = this.currentMonth.getFullYear();
        const month = this.currentMonth.getMonth();
        const monthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;

        const classes = allClasses.filter(c => c.startDate && c.startDate.startsWith(monthPrefix));

        const classesByDate = {};
        classes.forEach(c => {
            if (!classesByDate[c.startDate]) {
                classesByDate[c.startDate] = [];
            }
            classesByDate[c.startDate].push(c);
        });

        const extraSessions = [];

        Object.entries(classesByDate).forEach(([date, dayClasses]) => {
            const isOverlapping = dayClasses.length > 1;

            dayClasses.forEach(c => {
                const subject = DataManager.getSubject(c.subjectId);
                const normalStart = (subject && subject.defaultStartTime) || this.currentFormation.defaultStartTime;
                const normalEnd = (subject && subject.defaultEndTime) || this.currentFormation.defaultEndTime;
                const isOutOfSchedule = !!(normalStart && normalEnd) && (c.startTime !== normalStart || c.endTime !== normalEnd);

                if (!isOverlapping && !isOutOfSchedule) return;

                const professor = DataManager.getProfessor(c.professorId);

                extraSessions.push({
                    title: subject ? subject.name : 'Desconocido',
                    name: professor ? `${professor.firstName} ${professor.lastName} ` : 'Sin profesor',
                    date: Utils.formatDate(date),
                    rawDate: date,
                    time: `${c.startTime}-${c.endTime}`,
                    color: this.getColorForSubject(c.subjectId),
                    id: c.id,
                    isOverlapping,
                    isOutOfSchedule
                });
            });
        });

        extraSessions.sort((a, b) => String(a.rawDate).localeCompare(String(b.rawDate)) || a.time.localeCompare(b.time));
        const overlapping = extraSessions.filter(s => s.isOverlapping).length;
        const outOfSchedule = extraSessions.filter(s => s.isOutOfSchedule).length;
        const setText = (id, text) => { const el = document.getElementById(id); if (el) el.textContent = text; };
        setText('extra-sessions-count', String(extraSessions.length));
        setText('extra-sessions-total', String(extraSessions.length));
        setText('extra-sessions-caption', extraSessions.length ? `${overlapping} coincidentes · ${outOfSchedule} fuera de horario` : 'ninguna');

        if (extraSessions.length === 0) {
            SafeHTML.set(grid, '<p class="pg-empty">No hay sesiones extra ni coincidentes este mes.</p>');
            return;
        }

        const shortDate = value => {
            const d = new Date(`${value}T12:00:00`);
            return isNaN(d) ? Utils.formatDate(value) : d.toLocaleDateString('es-ES', { day: 'numeric', month: 'short' });
        };
        SafeHTML.set(grid, extraSessions.map(session => {
            const label = session.isOverlapping && session.isOutOfSchedule
                ? 'Coincidente · fuera de horario'
                : session.isOverlapping ? 'Coincidente' : 'Fuera de horario';
            return `
                <div class="pg-extra">
                    <span class="pg-extra-color" style="background: ${session.color};" aria-hidden="true"></span>
                    <span class="pg-extra-date">${Utils.sanitizeHTML(shortDate(session.rawDate))}</span>
                    <span class="pg-extra-body">
                        <b>${Utils.sanitizeHTML(session.title)}</b>
                        <span>${Utils.sanitizeHTML(session.name.trim())} · ${Utils.sanitizeHTML(session.time)}</span>
                    </span>
                    <span class="pg-extra-tag">${label}</span>
                </div>`;
        }).join(''));
    },

    renderDashboard() {
        if (!this.currentFormation) return;

        const year = this.currentMonth.getFullYear();
        const month = this.currentMonth.getMonth();
        const monthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;

        let monthClasses = DataManager.getClassesByFormation(this.currentFormation.id).filter(c => c.startDate && c.startDate.startsWith(monthPrefix));

        const professorHours = {};

        monthClasses.forEach(c => {
            let profId = c.professorId;
            if (!profId) {
                const subject = DataManager.getSubject(c.subjectId);
                if (subject) profId = subject.professorId;
            }

            if (!profId) return;

            const duration = Utils.calculateDuration(c.startTime, c.endTime);
            professorHours[profId] = (professorHours[profId] || 0) + duration;
        });

        const sortedProfessors = Object.entries(professorHours)
            .sort(([, a], [, b]) => b - a)
            .slice(0, 3);

        const profList = document.getElementById('top-professors-list');
        if (profList) {
            if (sortedProfessors.length === 0) {
                SafeHTML.set(profList, '<p class="text-secondary text-sm">No hay datos este mes.</p>');
            } else {
                SafeHTML.set(profList, sortedProfessors.map(([profId, hours]) => {
                    const prof = DataManager.getProfessor(profId);
                    const subjects = DataManager.getSubjectsByFormation(this.currentFormation.id).filter(s => s.professorId === profId);
                    const subjectName = subjects.length > 0 ? subjects[0].name : 'Varios';

                    return `
    <div style="display: flex; align-items: center; justify-content: space-between;" >
                            <div style="display: flex; align-items: center; gap: 1rem;">
                                <div style="width: 36px; height: 36px; border-radius: 50%; background: #E5E7EB; display: flex; align-items: center; justify-content: center; font-weight: 700; color: #374151; font-size: 0.8rem;">
                                    ${prof ? prof.firstName[0] + (prof.lastName ? prof.lastName[0] : '') : '??'}
                                </div>
                                <div>
                                    <div style="font-weight: 600; font-size: 0.9rem; color: var(--text-primary);">
                                        ${prof ? `${prof.firstName} ${prof.lastName}` : 'Desconocido'}
                                    </div>
                                    <div style="font-size: 0.75rem; color: var(--text-secondary);">
                                        ${Utils.sanitizeHTML(subjectName)}
                                    </div>
                                </div>
                            </div>
                            <div style="font-weight: 700; color: #10B981; font-size: 0.9rem;">
                                ${hours} Horas
                            </div>
                        </div>
    `;
                }).join(''));
            }
        }

        const typeCounts = {
            'COM': 0,
            'DPT': 0,
            'PRAC': 0,
            'EXT': 0
        };

        monthClasses.forEach(c => {
            const subject = DataManager.getSubject(c.subjectId);
            if (subject) {
                let typeKey = 'EXT';
                const sType = subject.type ? subject.type.toUpperCase() : '';

                if (sType.includes('COM')) typeKey = 'COM';
                else if (sType.includes('DEP') || sType.includes('DPT')) typeKey = 'DPT';
                else if (sType.includes('PRÁC') || sType.includes('PRAC')) typeKey = 'PRAC';

                typeCounts[typeKey] = (typeCounts[typeKey] || 0) + 1;
            }
        });

        const chart = document.getElementById('unit-distribution-chart');
        if (chart) {
            const maxVal = Math.max(...Object.values(typeCounts)) || 1;

            chart.style.alignItems = 'stretch';

            SafeHTML.set(chart, Object.entries(typeCounts).map(([type, count]) => {
                const heightPct = (count / maxVal) * 100;
                const barColors = {
                    'COM': '#10B981',
                    'DPT': '#6EE7B7',
                    'PRAC': '#059669',
                    'EXT': '#34D399'
                };

                return `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: flex-end; gap: 0.5rem; flex: 1; height: 100%;" >
                        <div style="width: 24px; height: ${Math.max(heightPct, 5)}%; background: ${barColors[type] || '#ccc'}; border-radius: 4px 4px 0 0; transition: height 0.6s ease;" title="${count} Unidades"></div>
                        <div style="font-size: 0.7rem; font-weight: 600; color: var(--text-secondary);">${type}</div>
                    </div>
    `;
            }).join(''));
        }
    },

    updateSummary() {
        if (!this.currentFormation) return;

        const classes = DataManager.getClassesByFormation(this.currentFormation.id);
        let totalMinutes = 0;
        let totalCost = 0;

        classes.forEach(c => {
            const durationHours = Utils.calculateDuration(c.startTime, c.endTime);
            totalMinutes += durationHours * 60;

            let profId = c.professorId;
            if (!profId) {
                const subject = DataManager.getSubject(c.subjectId);
                if (subject) profId = subject.professorId;
            }

            if (profId) {
                const professor = DataManager.getProfessor(profId);
                const rate = professor ? StaffPay.hourlyRate(professor) : 0;
                totalCost += durationHours * rate;
            }
        });

        const totalHours = Math.round(totalMinutes / 60);

        const hoursEl = document.getElementById('total-hours');
        const costEl = document.getElementById('total-cost');

        if (hoursEl) hoursEl.textContent = `${totalHours} h`;
        if (costEl) costEl.textContent = `${totalCost.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;
    },

    openExportModal() {
        if (!this.currentFormation) return;

        const academicMonths = [
            { m: 8, label: 'Septiembre' },
            { m: 9, label: 'Octubre' },
            { m: 10, label: 'Noviembre' },
            { m: 11, label: 'Diciembre' },
            { m: 0, label: 'Enero' },
            { m: 1, label: 'Febrero' },
            { m: 2, label: 'Marzo' },
            { m: 3, label: 'Abril' },
            { m: 4, label: 'Mayo' },
            { m: 5, label: 'Junio' },
            { m: 6, label: 'Julio' }
        ];

        const now = new Date();
        const baseYear = now.getMonth() >= 8 ? now.getFullYear() : now.getFullYear() - 1;

        const content = `
        <div style="padding: 1.5rem;" >
                <p style="margin-bottom: 1.5rem; color: var(--text-secondary);">Selecciona los meses que deseas exportar en el PDF de <strong>${Utils.sanitizeHTML(this.currentFormation.name)}</strong>:</p>
                
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 2rem;">
                    ${academicMonths.map(item => {
            const year = item.m >= 8 ? baseYear : baseYear + 1;
            return `
                            <label style="display: flex; align-items: center; gap: 0.75rem; padding: 0.75rem; background: var(--bg-tertiary); border-radius: 8px; cursor: pointer;">
                                <input type="checkbox" class="month-selector" value="${year}-${item.m}" checked style="width: 1.2rem; height: 1.2rem; accent-color: var(--primary-color);">
                                <span>${Utils.sanitizeHTML(item.label)} ${year}</span>
                            </label>
                        `;
        }).join('')}
                </div>

                <div style="display: flex; justify-content: space-between; align-items: center; border-top: 1px solid var(--border-color); padding-top: 1.5rem; margin-top: 1rem;">
                    <button class="btn btn-secondary" ${UIEvents.attr("click", function(event,captured){Utils.closeModal();}, [])}>Cancelar</button>
                    <button class="btn btn-primary" ${UIEvents.attr("click", function(event,captured){ProgramView.handleExportClick();}, [])}>
                        <i class="fas fa-file-download"></i> Generar PDF
                    </button>
                </div>
            </div>
    `;

        Utils.openModal('Exportar Programación', content);
    },

    handleExportClick() {
        const selected = Array.from(document.querySelectorAll('.month-selector:checked')).map(cb => {
            const [year, month] = cb.value.split('-').map(Number);
            return { year, month };
        });

        if (selected.length === 0) {
            Utils.showToast('Selecciona al menos un mes', 'warning');
            return;
        }

        this.generateMultiMonthPDF(selected);
    },

    generateMultiMonthPDF(selectedMonths) {
        Utils.showToast('Generando vista de impresión...', 'info');
        Utils.closeModal();

        const printContainer = document.getElementById('print-container');
        if (!printContainer) return;

        const now = new Date();
        const yearStart = now.getMonth() >= 8 ? now.getFullYear() : now.getFullYear() - 1;
        const courseYear = `CURSO ${yearStart}/${yearStart + 1}`;

        let html = `
            <table class="print-layout-table">
                <thead>
                    <tr>
                        <td>
                            <div class="print-only-header">
                                <div class="print-header-left">
                                    <h1 class="print-school-name">${Utils.sanitizeHTML([SchoolService.get('shortName'), SchoolService.get('name')].filter(Boolean).join(' - ') || SchoolService.name())}</h1>
                                    <p class="print-course-year">${courseYear}</p>
                                    <h2 class="print-formation-name">${Utils.sanitizeHTML(this.currentFormation.name)}</h2>
                                </div>
                                <div class="print-header-right">
                                    <div class="print-logo-box">
                                        ${SchoolService.logoHtml(['logoUrl', 'emailLogoUrl'], 'class="print-logo"')}
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <div class="academic-rows-container">
                                ${selectedMonths.map(m => `
                                    <div class="academic-month-row">
                                        <div class="academic-month-calendar">
                                            ${this.renderStaticCalendar(m.year, m.month)}
                                        </div>
                                        <div class="academic-month-sessions">
                                            ${this.renderPrintSessionsList(m.year, m.month)}
                                        </div>
                                    </div>
                                `).join('')}
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tfoot class="print-only-footer-wrapper">
                    <tr>
                        <td>
                            <div class="print-only-footer">
                                <p>* ${Utils.sanitizeHTML(SchoolService.shortName())} se reserva el derecho a modificar los calendarios tanto en horarios como en fechas</p>
                            </div>
                        </td>
                    </tr>
                </tfoot>
            </table>
        `;

        SafeHTML.set(printContainer, html);

        setTimeout(() => {
            window.print();
        }, 500);
    },

    renderStaticCalendar(year, month) {
        const monthNames = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

        const firstDay = new Date(year, month, 1);
        const lastDay = new Date(year, month + 1, 0);
        const daysInMonth = lastDay.getDate();
        let startDayOfWeek = firstDay.getDay();

        startDayOfWeek = startDayOfWeek === 0 ? 6 : startDayOfWeek - 1;

        let html = `
            <div class="mini-month-card">
                <h4 class="mini-month-title">${monthNames[month]} ${year}</h4>
                <div class="mini-calendar-grid">
        `;

        ['L', 'M', 'X', 'J', 'V', 'S', 'D'].forEach(day => {
            html += `<div class="mini-calendar-header">${day}</div>`;
        });

        for (let i = 0; i < startDayOfWeek; i++) {
            html += '<div class="mini-calendar-day empty"></div>';
        }

        for (let day = 1; day <= daysInMonth; day++) {
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
            const isHoliday = DataManager.isHoliday(dateStr);
            const dayClasses = this.getClassesForDay(year, month, day);
            const classNames = ['mini-calendar-day'];
            let style = '';

            if (isHoliday) {
                classNames.push('is-holiday');
            }

            if (dayClasses.length > 0) {
                classNames.push('has-classes');
                if (!isHoliday) {
                    if (dayClasses.length === 1) {
                        const subject = DataManager.getSubject(dayClasses[0].subjectId);
                        const color = subject?.color || '#ccc';
                        style = `background-color: ${color}; color: white;`;
                    } else {
                        const colors = [...new Set(dayClasses.map(c => {
                            const subject = DataManager.getSubject(c.subjectId);
                            return subject?.color || '#ccc';
                        }))];
                        const percent = 100 / colors.length;
                        const gradient = colors.map((c, i) => `${c} ${i * percent}% ${(i + 1) * percent}%`).join(', ');
                        style = `background: linear-gradient(135deg, ${gradient}); color: white;`;
                    }
                }
            }

            html += `
                <div class="${classNames.join(' ')}" style="${style}">
                    ${day}
                </div>
            `;
        }

        html += '</div></div>';
        return html;
    },

    renderPrintSessionsList(year, month) {
        if (!this.currentFormation) return '';

        const classes = DataManager.getClassesByFormation(this.currentFormation.id);
        const monthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;
        const monthClasses = classes.filter(c => c.startDate && c.startDate.startsWith(monthPrefix));

        if (monthClasses.length === 0) {
            return '<p style="text-align: center; color: var(--text-secondary); padding: 2rem;">No hay clases programadas.</p>';
        }

        const groups = {};
        monthClasses.forEach(cls => {
            const key = `${cls.subjectId}-${cls.startTime}-${cls.endTime}`;
            if (!groups[key]) {
                const subject = DataManager.getSubject(cls.subjectId);
                groups[key] = {
                    subjectId: cls.subjectId,
                    subjectName: subject ? subject.name : 'Asignatura',
                    color: subject?.color || '#ccc',
                    type: subject?.type || 'COMÚN',
                    startTime: cls.startTime,
                    endTime: cls.endTime,
                    days: []
                };
            }
            const dayNumber = parseInt(String(cls.startDate).split('-')[2], 10);
            if (!Number.isNaN(dayNumber) && !groups[key].days.includes(dayNumber)) {
                groups[key].days.push(dayNumber);
            }
        });

        const baseSchedule = this.getFormationDefaultSchedule();

        const sortedGroups = Object.values(groups).sort((a, b) => {
            if (a.startTime !== b.startTime) return a.startTime.localeCompare(b.startTime);
            return a.subjectName.localeCompare(b.subjectName);
        });

        // Marca los tramos que no coinciden con el horario general de la formación
        const isOutOfSchedule = (group) => !!baseSchedule &&
            (group.startTime !== baseSchedule.startTime || group.endTime !== baseSchedule.endTime);

        return `
            <div class="compact-sessions-container">
                <div class="compact-sessions-header">
                    <div class="col-header">COL</div>
                    <div class="col-header">ASIGNATURA Y FORMACIÓN</div>
                    <div class="col-header">TIPO</div>
                    <div class="col-header">OBS.</div>
                </div>
                <div class="compact-sessions-list">
                    ${sortedGroups.map(group => `
                        <div class="compact-session-row">
                            <div class="session-col">
                                <div class="color-dot" style="background: ${group.color}"></div>
                            </div>
                            <div class="session-info">
                                <span class="subject-name">${Utils.sanitizeHTML(group.subjectName)}</span>
                            </div>
                            <div class="session-type">
                                <span class="type-badge">${group.type}</span>
                            </div>
                            <div class="session-obs">
                                <span class="days-text">${group.days.sort((a, b) => a - b).join(', ')}</span>
                                <span class="time-text${isOutOfSchedule(group) ? ' is-out-of-schedule' : ''}"
                                      title="${isOutOfSchedule(group) ? `Distinto del horario general de la formación (${baseSchedule.startTime} - ${baseSchedule.endTime})` : ''}">${group.startTime} - ${group.endTime}</span>
                            </div>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    },

    calculateLoadStatus() {
        if (!this.currentFormation) return { percentage: 0, assigned: 0, total: 0 };

        const month = this.currentMonth.getMonth();
        const year = this.currentMonth.getFullYear();

        const startDate = new Date(year, month, 1);
        const endDate = new Date(year, month + 1, 0);

        const holidays = DataManager.getHolidays();
        let totalWorkingDays = 0;
        const workingDates = new Set();
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            const day = currentDate.getDay(); // 0=Sun, 6=Sat

            const y = currentDate.getFullYear();
            const m = String(currentDate.getMonth() + 1).padStart(2, '0');
            const d = String(currentDate.getDate()).padStart(2, '0');
            const dateStr = `${y}-${m}-${d}`;

            if (day !== 0 && day !== 6 && !holidays.includes(dateStr)) {
                totalWorkingDays++;
                workingDates.add(dateStr);
            }

            currentDate.setDate(currentDate.getDate() + 1);
        }

        const classes = DataManager.getClassesByFormation(this.currentFormation.id);
        const monthPrefix = `${year}-${String(month + 1).padStart(2, '0')}`;

        const assignedWorkingDates = new Set(classes
            .filter(c => c.startDate && c.startDate.startsWith(monthPrefix) && workingDates.has(c.startDate))
            .map(c => c.startDate)
        );
        const assignedCount = assignedWorkingDates.size;

        console.log(`[DEBUG] calculateLoadStatus for ${monthPrefix}:`, {
            totalWorkingDays,
            workingDatesSize: workingDates.size,
            assignedCount,
            assignedWorkingDates: [...assignedWorkingDates],
            allClassesInMonth: classes.filter(c => c.startDate && c.startDate.startsWith(monthPrefix)).length
        });

        let percentage = 0;
        if (totalWorkingDays > 0) {
            percentage = Math.round((assignedCount / totalWorkingDays) * 100);
        }

        return {
            percentage: Math.min(percentage, 100),
            assigned: assignedCount,
            total: totalWorkingDays
        };
    },

    updateLoadStatus() {
        const status = this.calculateLoadStatus();
        console.log('[DEBUG] updateLoadStatus:', status);

        const percentEl = document.getElementById('progress-percentage');
        const barEl = document.getElementById('progress-bar-fill');
        const statsEl = document.getElementById('progress-stats-label');

        if (percentEl) percentEl.textContent = `${status.percentage}%`;
        if (barEl) barEl.style.width = `${status.percentage}%`;
        if (statsEl) {
            console.log(`[DEBUG] Updating statsEl with: ${status.assigned} de ${status.total} días lectivos`);
            statsEl.textContent = `${status.assigned} de ${status.total} días lectivos`;
        }
    }
});
